import fa from './fa/translation.json';

export default {
  fa: {
    translation: fa
  }
};
